// extracted by mini-css-extract-plugin
export default {"container":"AuthLayout_container__JqRqg","card":"AuthLayout_card__uYwX2","logo":"AuthLayout_logo__1RwHO","title":"AuthLayout_title__ah4wW"};